import React from 'react';
import * as S from './CancelStatusPop.styles';

import IconSelector from '@ibibo/icon-selector';

const CancelStatusPop = ({data, navigateToMyTrips}) => {
  const {msg, status_color, sub_msg = ''} = data;
  return(
    <S.CancelStatusPopMainWrap>
      <S.StatusHeadWrap color={status_color}>
        <S.StatusTextWrap>
          <S.StatusText>{msg ? msg : 'Something went wrong'}</S.StatusText>
        </S.StatusTextWrap>
        <S.StatusImgWrap>
          <IconSelector iconKey='cancelsubmit'/>
        </S.StatusImgWrap>
      </S.StatusHeadWrap>
      <S.StatusInfoWrap>
        <S.StatusInfoText>{sub_msg}</S.StatusInfoText>
        <S.StatusBtnWrap onClick={navigateToMyTrips}>
          <S.StatusBtn>BACK TO MY BOOKING</S.StatusBtn>
        </S.StatusBtnWrap>
      </S.StatusInfoWrap>
    </S.CancelStatusPopMainWrap>
  );
}

export default CancelStatusPop;




export const StatusPop = ({callWhatsappLogin, actions}) => {
    return(
      <S.CancelStatusPopMainWrap>
        <S.StatusHeadWrap color={'blue'}>
        <S.StatusTextWrap>
          <S.StatusText>Your booking is confirmed</S.StatusText>
        </S.StatusTextWrap>
          <S.StatusImgWrap>
            <IconSelector iconKey='cancelsubmit'/>
          </S.StatusImgWrap>
        </S.StatusHeadWrap>
        <S.StatusInfoWrap>
          <S.StatusInfoText>Click Continue to share booking confirmation with the customer directly from your WhatsApp account</S.StatusInfoText>
          <S.StatusBtnWrap onClick={()=>{
              let link = ''
              actions.forEach(element => {
                  if (element.icon == 'whatsapp'){
                    link = element.link
                  }
              });
              callWhatsappLogin(link)
              }}>
            <S.StatusBtn>Continue</S.StatusBtn>
          </S.StatusBtnWrap>
        </S.StatusInfoWrap>
      </S.CancelStatusPopMainWrap>
    );
  }
